import { Favorite } from '@tunasong/icons'
import { type FC } from 'react'
import { useFavorites } from './favorites.hook.js'
import type { FavoriteControlProps } from './favorite-props.js'
import { ListItemIcon, ListItemText, MenuItem, type MenuItemProps } from '../primitives/index.js'

type FavoriteMenuItemProps = FavoriteControlProps<MenuItemProps>

export const FavoriteMenuItem: FC<FavoriteMenuItemProps> = props => {
  const { onClick, entity, ...restProps } = props
  const { toggleFavorite, isFavorite, getFavoriteTemplateFromEntity } = useFavorites()

  const favorite = isFavorite(entity)

  return (
    <MenuItem
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        toggleFavorite(getFavoriteTemplateFromEntity(entity))
        if (onClick) {
          onClick(ev)
        }
      }}
      {...restProps}
    >
      <ListItemIcon>
        <Favorite color={favorite ? 'var(--tuna-palette-error-main)' : 'currentColor'} />
      </ListItemIcon>
      <ListItemText primary={favorite ? 'Remove from favorites' : 'Add to favorites'} />
    </MenuItem>
  )
}

export default FavoriteMenuItem
